<div class="qr-page" *ngIf="connectorExists; else notFoundTemplate">
  <header class="qr-page-header">
    <a class="brand" href="/">
      <img *ngIf="tenantLogo" class="brand-logo" [src]="tenantLogo" alt="">
      <ng-container *ngIf="!tenantLogo"><mat-icon>bolt</mat-icon><span>{{ tenantName || ('qrcode.brand' | translate) }}</span></ng-container>
    </a>
    <div class="header-right">
      <button mat-button class="header-help" (click)="redirectToEv24()">{{'qrcode.help' | translate}}</button>
      <div class="header-context"><mat-icon>ev_station</mat-icon><span>{{'qrcode.charging_Station' | translate}}</span></div>
      <div class="lang-selector">
        <button class="lang-btn" [class.active]="selectedLanguage === 'fr'" (click)="changeLanguage('fr')">FR</button>
        <button class="lang-btn" [class.active]="selectedLanguage === 'en'" (click)="changeLanguage('en')">EN</button>
      </div>
    </div>
  </header>

  <main class="qr-main">
    <section class="station-heading" *ngIf="chargingStation">
      <div>
        <span class="session-status"><span></span>{{'qrcode.connector' | translate}} {{ connectorId }}</span>
        <h1>{{ chargingStation.id }}</h1>
        <div class="station-meta">
          <span *ngIf="chargingStation.siteArea?.name"><mat-icon>location_on</mat-icon>{{ chargingStation.siteArea.name }}</span>
          <span *ngIf="chargingStation.site?.address?.address1"><mat-icon>map</mat-icon>{{ chargingStation.site.address.address1 }}</span>
        </div>
      </div>
      <span class="connector-badge" [ngStyle]="{'background-color': connectorStatusColor}">{{ connectorStatus }}</span>
    </section>

    <div class="qr-loading" *ngIf="!chargingStation">
      <mat-spinner diameter="44"></mat-spinner>
    </div>

    <article class="pricing-card" *ngIf="pricingDefinitions">
      <div class="card-title"><mat-icon>receipt_long</mat-icon><h2>{{'qrcode.tariff' | translate}}</h2></div>
      <div class="pricing-row" *ngIf="hasFlatFee"><span>{{'qrcode.FlatFee' | translate}}</span><strong>{{ pricingDefinitions.dimensions.flatFee.price }} €</strong></div>
      <div class="pricing-row" *ngIf="hasEnergy"><span>{{'qrcode.Energy' | translate}}</span><strong>{{ pricingDefinitions.dimensions.energy.price }} €/kWh</strong></div>
      <div class="pricing-row" *ngIf="hasChargingTime"><span>{{'qrcode.ChargingTime' | translate}}</span><strong>{{ pricingDefinitions.dimensions.chargingTime.price }} €/h</strong></div>
      <div class="pricing-row" *ngIf="hasParkingTime"><span>{{'qrcode.Parkingtime' | translate}}</span><strong>{{ pricingDefinitions.dimensions.parkingTime.price }} €/h</strong></div>
    </article>

    <article class="payment-card">
      <div class="card-title"><mat-icon>credit_card</mat-icon><h2>{{'qrcode.Paymentmethod' | translate}}</h2></div>
      <p class="payment-desc">{{'qrcode.enter_email' | translate}}</p>
      <form [formGroup]="cardForm" class="payment-form">
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{'qrcode.email' | translate}}</mat-label>
          <input matInput type="email" autocomplete="off" formControlName="email" placeholder="name@mail.com">
          <mat-icon matSuffix>email</mat-icon>
          <mat-error *ngIf="cardForm.controls['email'].invalid && cardForm.controls['email'].touched">
            <small *ngIf="cardForm.controls['email'].hasError('required')">{{'qrcode.email_required' | translate}}</small>
            <small *ngIf="cardForm.controls['email'].hasError('email')">{{'payment.invalide' | translate}}</small>
          </mat-error>
        </mat-form-field>
        <button mat-flat-button class="primary-action full-width" (click)="redirectToPayment()">
          <span>{{'qrcode.Use_credit_card' | translate}}</span><mat-icon>arrow_forward</mat-icon>
        </button>
      </form>
    </article>
  </main>
</div>

<ng-template #notFoundTemplate>
  <div class="qr-page">
    <header class="qr-page-header">
      <a class="brand" href="/">
        <img *ngIf="tenantLogo" class="brand-logo" [src]="tenantLogo" alt="">
        <ng-container *ngIf="!tenantLogo"><mat-icon>bolt</mat-icon><span>{{ tenantName || ('qrcode.brand' | translate) }}</span></ng-container>
      </a>
      <div class="header-right">
        <button mat-button class="header-help" (click)="redirectToEv24()">{{'qrcode.help' | translate}}</button>
        <div class="header-context"><mat-icon>ev_station</mat-icon><span>{{'qrcode.charging_Station' | translate}}</span></div>
        <div class="lang-selector">
          <button class="lang-btn" [class.active]="selectedLanguage === 'fr'" (click)="changeLanguage('fr')">FR</button>
          <button class="lang-btn" [class.active]="selectedLanguage === 'en'" (click)="changeLanguage('en')">EN</button>
        </div>
      </div>
    </header>
    <main class="qr-main">
      <article class="not-found-card">
        <mat-icon>link_off</mat-icon>
        <h2>{{'qrcode.ConnectorNotFound' | translate}}</h2>
        <p>{{'qrcode.call_or_message' | translate}}</p>
      </article>
    </main>
  </div>
</ng-template>
